import { Set } from 'immutable'
import { ProcessedSpecialists } from './specialistOverviewState'
import { alphabetize } from '../azNavigation/azNavigationUtils'
import { SpecialistPage } from '../cmsPage/cmsPageState'

const filterSpecialists = (data: SpecialistPage[], department: string, role: string, searchTerm: string): SpecialistPage[] =>
  data.filter(
    (x) =>
      x.specialist &&
      (department == '' ||
        x.specialist.departments.some((d) => d.toLowerCase() == department.toLowerCase()) ||
        x.specialist.subDepartments.some((s) => s.toLowerCase() == department.toLowerCase()) ||
        x.specialist.centra.some((c) => c.toLowerCase() == department.toLowerCase())) &&
      (role == '' ||
        x.specialist.role.toLowerCase() == role.toLowerCase()) &&
      (searchTerm == '' ||
        x.specialist.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.specialist.tussenvoegsel.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.specialist.surName.toLowerCase().includes(searchTerm.toLowerCase()))
  )

// Constructs alphabetically grouped, alphabetically sorted lists of specialists with doctors at the top
export const processSpecialistData = (
  data: SpecialistPage[],
  department: string,
  role: string,
  query: string
): ProcessedSpecialists => {
  const departments = data.reduce<Set<string>>(
    (acc, r) => acc.concat(r.specialist?.centra || []),
    data.reduce<Set<string>>((acc, r) => acc.concat(r.specialist?.departments || []), Set())
  )

  const roles = Set(data.map((page) => page.specialist?.role || ""));

  const filtered = filterSpecialists(data, department, role, query)
  const groups = alphabetize((s) => s.specialist?.surName || '', filtered)
  return { departments, roles: roles, groups: groups }
}
